import React, { Component } from "react";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import {
    Button,
    CircularProgress,
    Grid,
    Container,
    Box,
    FormControl,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Slide,
    Toolbar,
    TextField,
    AppBar,
    IconButton,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
} from "@material-ui/core";
import { ArrowBackRounded, Comment, Map, PhotoSizeSelectActual, Fullscreen, Close } from "@material-ui/icons";
import { ReportIncidentButton } from "../components";
import SamsynMap from "../components/custom/SamsynMap";

const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    bgwhite: {
        background: "white",
    },
    bgfullwhite: {
        background: "white",
        height: 900,
    },
    menuButton: {
        padding: "0px",
    },
    userName: {
        flexGrow: 1,
        textAlign: "center",
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export class WinterWorkClock extends Component {
    static displayName = WinterWorkClock.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            privileges: this.props.crmPrivileges,
            currentUser: {
                id: props.user.id,
                name: props.user.name,
                lang: props.user.lang,
            },
            projectLineId: props.match.params.id,
            accountLocation: [],
            isStarted: false,
            isStopped: false,
            submitted: false,
            vehicle: null,
            projectLine: [],
            mapUrl: "https://gardlist.samsyn.is/svaedasja/",
            totalTime: 0,
            actionLoading: false,
            description: "",
            issue: "",
            unsavedChanges: false,
            redirect: false,
            relatedProjectLines: [],
            startedOn: "Start",
            stoppedOn: "Stop",
            serviceType: "",
            totalInGroup: 1,
            descriptionLines: 4,
            fullscreen: false,
            inMemory: {
                selectedList: this.props.location.state.selectedList,
                selectedPostalCode: this.props.location.state.selectedPostalCode,
            },
        };

        this.getProjectLineData(this.state.projectLineId);
    }

    componentDidMount = () => {};

    loadProjectLineData = (projectLineId) => {};

    //Get details about current project line.
    getProjectLineData = (id) => {
        if (id != null) {
            axios.get("/api/common/project-lines/" + id).then((res) => {
                const projectLine = res.data;

                const vehicle = projectLine.vehicle ?? null;
                const started = projectLine.checkIn != null;
                const stopped = projectLine.checkOut != null;

                const submitted = (started && stopped) || projectLine.skipped;
                const totalTime = projectLine.totalTime != null ? projectLine.totalTime : 0;
                const issue = projectLine.issue != null ? projectLine.issue : "";

                const addressId = projectLine?.project?.address?.id;

                // Get project location description
                if (addressId && addressId !== null) {
                    axios.get("/api/common/project-locations/" + addressId + "/services/Vetrarverk").then((res) => {
                        const accountLocation = res.data;
                        if (this.state.currentUser.lang == null || this.state.currentUser.lang === 810360000) {
                            this.setState({ description: accountLocation?.description ?? accountLocation?.descriptionEnglish ?? "" });
                        } else {
                            this.setState({ description: accountLocation?.descriptionEnglish ?? accountLocation?.description ?? "" });
                        }
                    });
                }

                //Get all project lines in the same project by id
                if (projectLine.project != null) {
                    axios.get("/api/winterwork/GetWinterWorkProjectLinesRegardingProjectId/" + projectLine.project.id).then((res) => {
                        const relatedProjectLines = res.data;

                        const allRelatedExceptCurrent = relatedProjectLines.filter(function (line) {
                            return line.id !== projectLine.id;
                        });
                        this.setState({ relatedProjectLines: allRelatedExceptCurrent });
                    });
                }

                const startedOnInit = started ? "Started: " + new Date(projectLine.checkIn).toLocaleString("de-GE") : "Start";
                const stoppedOnInit = stopped ? "Stopped: " + new Date(projectLine.checkOut).toLocaleString("de-GE") : "Stop";
                const projectLineServiceType = projectLine.project != null && projectLine.project.serviceType != null ? projectLine.project.serviceType.name : null;
                this.setState({
                    projectLine,
                    submitted,
                    vehicle,
                    isStarted: started,
                    isStopped: stopped,
                    loading: false,
                    totalTime: totalTime,
                    issue,
                    startedOn: startedOnInit,
                    stoppedOn: stoppedOnInit,
                    serviceType: projectLineServiceType,
                });
            });
        }
    };

    start = () => {
        this.setState({ actionLoading: true });
        var options = {
            enableHighAccuracy: true,
            timeout: 60000, //try for 1 min before stop trying to get location
            maximumAge: 0, //do not use cached location
        };

        //Get location before checkin
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.handleStart(position);
            },
            this.handleError,
            options
        );
    };
    handleStart = (position) => {
        const coords = position != null ? { lat: position.coords.latitude, lon: position.coords.longitude } : { lat: 0, lon: 0 };
        const currentDate = new Date();
        const worker = this.state.currentUser;
        const totalInGroup = this.state.totalInGroup;

        axios
            .put("/api/common/project-lines", {
                Location: {
                    Latitude: coords.lat,
                    Longitude: coords.lon,
                },
                ProjectLine: this.state.projectLine,
                CheckIn: currentDate,
                Worker: worker,
                TotalInGroup: totalInGroup,
            })
            .then((res) => {
                this.props.enqueueSnackbar("Successfully started projectline", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ isStarted: true, actionLoading: false, startedOn: "Started: " + new Date().toLocaleString("de-GE") });
            })
            .catch((err) => {
                // handle error
                this.props.enqueueSnackbar("Error occurred when starting projectline", {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ actionLoading: false });
            });
    };
    stop = () => {
        this.setState({ actionLoading: true });

        var options = {
            enableHighAccuracy: true,
            timeout: 60000, //try for 1 min before stop trying to get location
            maximumAge: 0, //do not use cached location
        };

        //Get location before checkin
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.handleStop(position);
            },
            this.handleError,
            options
        );
    };
    handleStop = (position) => {
        const coords = position != null ? { lat: position.coords.latitude, lon: position.coords.longitude } : { lat: 0, lon: 0 };
        const currentDate = new Date();
        const worker = this.state.currentUser;
        const totalInGroup = this.state.totalInGroup;
        axios
            .put("/api/common/project-lines", {
                Location: {
                    Latitude: coords.lat,
                    Longitude: coords.lon,
                },
                ProjectLine: this.state.projectLine,
                CheckOut: currentDate,
                Worker: worker,
                TotalInGroup: totalInGroup,
            })
            .then((res) => {
                this.props.enqueueSnackbar("Successfully stopped projectline", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });

                const totalTime = res.data.totalTime != null ? res.data.totalTime : 0;

                this.setState({ isStopped: true, submitted: true, totalTime: totalTime, actionLoading: false, stoppedOn: "Stopped: " + new Date().toLocaleString("de-GE") });
            })
            .catch((err) => {
                // handle error
                this.props.enqueueSnackbar("Error occurred when stopping projectline", {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ actionLoading: false });
            });
    };

    handleError = (error) => {
        var message = "";
        switch (error.code) {
            case error.PERMISSION_DENIED:
                message = "This website does not have permission to use the location.";
                break;
            case error.POSITION_UNAVAILABLE:
                message = "The current position is unavailable.";
                break;
            case error.TIMEOUT:
                message = "The current position could not be determined within the specified timeout period. Try again.";
                break;
            default:
                message = "Error getting current location";
                break;
        }

        this.props.enqueueSnackbar(message, {
            variant: "error",
            autoHideDuration: 3000,
            preventDuplicate: true,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            },
        });
    };

    skip = () => {
        //Ekki hægt að skippa nema
        if (this.state.issue == null || this.state.issue.length < 4) {
            this.props.enqueueSnackbar("Cannot skip line without issue description (please update the issue)", {
                variant: "warning",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                },
            });
            return;
        }

        this.setState({ actionLoading: true });

        var options = {
            enableHighAccuracy: true,
            timeout: 60000, //try for 1 min before stop trying to get location
            maximumAge: 0, //do not use cached location
        };

        //Get location before checkin
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.handleSkip(position);
            },
            this.handleError,
            options
        );
    };

    handleSkip = (position) => {
        const coords = position != null ? { lat: position.coords.latitude, lon: position.coords.longitude } : { lat: 0, lon: 0 };
        const currentDate = new Date();
        const worker = this.state.currentUser;
        axios
            .post("/api/winterwork/SkipWinterWorkProjectLine", {
                Location: {
                    Latitude: coords.lat,
                    Longitude: coords.lon,
                },
                ProjectLine: this.state.projectLine,
                Skip: true,
                DateSkipped: currentDate,
                Worker: worker,
            })
            .then((res) => {
                this.props.enqueueSnackbar("Successfully skipped projectline", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ submitted: true, actionLoading: false });
            })
            .catch((err) => {
                // handle error
                this.props.enqueueSnackbar("Error occurred when skipping projectline", {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
                this.setState({ actionLoading: false });
            });
    };

    fullScreenMe = (event) => {
        this.setState({ fullscreen: !this.state.fullscreen });
        this.setState({ descriptionLines: this.state.descriptionLines === 4 ? 30 : 4 });

        //alert("Full screen " + input);
    };

    handleClickOpen = () => {
        this.setState({ fullscreen: true });
    };

    handleClose = () => {
        this.setState({ fullscreen: false });
    };

    handleIssueInput = (event) => {
        const input = event.target.value;

        if (input !== this.state.issue) {
            this.setState({ issue: input, unsavedChanges: true });
        }
    };

    saveUserComment = (event) => {
        const input = event.target.value;

        axios
            .put("/api/common/project-lines", {
                ProjectLine: this.state.projectLine,
                Issue: input,
                TotalInGroup: this.state.totalInGroup,
            })
            .then((res) => {
                this.props.enqueueSnackbar("Successfully updated issue for project line", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });

                this.setState({ issue: input, unsavedChanges: false });
            })
            .catch((err) => {
                this.props.enqueueSnackbar("Error occurred when updating issue for projectline", {
                    variant: "error",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    },
                });
            });
    };

    renderMain = (props) => {
        const { classes } = props;
        return (
            <Container style={{ maxWidth: "100%" }}>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        {this.state.actionLoading ? (
                            <Grid container spacing={2} className={classes.centered} style={{ textAlign: "center" }}>
                                <Grid item xs={12}>
                                    <CircularProgress />
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container spacing={3} className={classes.centered}>
                                <Grid item xs={12}>
                                    <Grid container spacing={1} direction="row" justifyContent="flex-end" alignItems="baseline">
                                        <Grid item xs={12}>
                                            <Grid container direction="column" justifyContent="flex-start" alignItems="flex-end">
                                                <IconButton aria-label="Full screen" onClick={this.fullScreenMe}>
                                                    <Fullscreen />
                                                </IconButton>
                                                <TextField
                                                    id="outlined-multiline-static"
                                                    label="Description"
                                                    multiline
                                                    minRows={4}
                                                    onClick={this.fullScreenMe}
                                                    className={!this.state.fullscreen ? classes.bgwhite : classes.bgfullwhite}
                                                    value={this.state.description != null ? this.state.description : "Óskráð"}
                                                    variant="outlined"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Issue"
                                        multiline
                                        minRows={4}
                                        value={this.state.issue}
                                        onChange={this.handleIssueInput}
                                        onBlur={this.saveUserComment}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} style={{ width: "100%" }}>
                                        <Button variant="contained" color="primary" disabled={this.state.submitted || this.state.isStarted ? true : false} onClick={this.start}>
                                            {this.state.startedOn}
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} style={{ width: "100%" }}>
                                        <Button variant="contained" color="primary" disabled={this.state.submitted || !this.state.isStarted ? true : false} onClick={this.stop}>
                                            {this.state.stoppedOn}
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} style={{ width: "100%" }}>
                                        <TextField
                                            variant="outlined"
                                            label="Time measurement"
                                            value={this.state.totalTime}
                                            type="number"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl className={classes.formControl} style={{ width: "100%" }}>
                                        <Button variant="contained" color="primary" disabled={this.state.submitted || this.state.isStarted ? true : false} onClick={this.skip}>
                                            Skip
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button variant="outlined" startIcon={<PhotoSizeSelectActual />} color="primary" onClick={this.openPhotos}>
                                        Photos
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box display="flex" justifyContent="flex-end">
                                        <ReportIncidentButton projectLineId={this.state.projectLineId} />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} style={{ height: 50 + "%" }}>
                                    <SamsynMap
                                        locationId={this.state?.projectLine?.project?.address?.id}
                                        latitude={this.state?.projectLine?.project?.address?.latitude}
                                        longitude={this.state?.projectLine?.project?.address?.longitude}
                                        serviceType="Vetrarverk"
                                    />
                                </Grid>
                                {this.state.relatedProjectLines.length > 0 ? (
                                    <Grid item xs={12}>
                                        <Typography variant="h6" className={classes.title}>
                                            Related Issues
                                        </Typography>
                                        <div>
                                            <List dense={true} style={{ maxHeight: "25vh", overflow: "auto" }}>
                                                {this.state.relatedProjectLines.map((projectLine) => (
                                                    <ListItem key={projectLine.id} style={{ width: "100%" }}>
                                                        <ListItemIcon>
                                                            <Comment />
                                                        </ListItemIcon>
                                                        <ListItemText style={{ wordWrap: "break-word" }} primary={projectLine.issue} secondary={projectLine.workingDateFormatted}></ListItemText>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </div>
                                    </Grid>
                                ) : null}
                            </Grid>
                        )}
                    </Grid>
                </div>
                <Dialog fullScreen open={this.state.fullscreen} onClose={this.handleClose} TransitionComponent={Transition}>
                    {" "}
                    <DialogContent>
                        <DialogContentText>
                            <AppBar sx={{ position: "relative" }}>
                                <Toolbar>
                                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                        <Close />
                                    </IconButton>
                                    <Typography gutterBottom>{this.state.accountLocation.name}</Typography>
                                </Toolbar>
                            </AppBar>
                            <Box sx={{ my: 8, mx: 0 }}>
                                <TextField
                                    id="outlined-multiline-static-full"
                                    label="Description"
                                    multiline
                                    value={this.state.description != null ? this.state.description : "Óskráð"}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        );
    };

    openGoogleMaps = () => {
        let url = "https://maps.google.com/?q=" + this.state.projectLine?.project?.address?.latitude + "," + this.state.projectLine?.project?.address?.longitude;
        const newWindow = window.open(url, "Garðlist Maps", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };

    openPhotos = () => {
        var callback = this.props.history.push("/photos/" + this.state.projectLineId, { accountLocation: this.state.accountLocation.name, currWorkType: this.state.serviceType });
        this.saveAndRedirect(callback);
    };

    saveAndRedirect = (whereTo) => {
        const unsavedText = this.state.issue;

        if (this.state.unsavedChanges) {
            axios
                .put("/api/common/project-lines", {
                    ProjectLine: this.state.projectLine,
                    Issue: unsavedText,
                    TotalInGroup: this.state.totalInGroup,
                })
                .then((res) => {
                    this.setState({ redirect: true });
                    this.props.enqueueSnackbar("Successfully updated issue for project line", {
                        variant: "success",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                    });
                    //              this.props.history.push("/winterwork/", { selectedList: this.state.inMemory.selectedList, selectedPostalCode: this.state.inMemory.selectedPostalCode });
                    if (whereTo === "back") {
                        if (this.props.location.state && this.props.location.state.from) {
                            this.props.history.goBack();
                        } else {
                            this.props.history.push("/winterwork/", { selectedList: this.state.inMemory.selectedList, selectedPostalCode: this.state.inMemory.selectedPostalCode });
                        }
                    } else {
                        eval(whereTo);
                    }
                })
                .catch((err) => {
                    this.props.enqueueSnackbar("Error occurred when updating issue for projectline", {
                        variant: "error",
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                    });
                });
        } else {
            //this.props.history.push("/winterwork/", { selectedList: this.state.inMemory.selectedList, selectedPostalCode: this.state.inMemory.selectedPostalCode });
            if (whereTo === "back") {
                if (this.props.location.state && this.props.location.state.from) {
                    this.props.history.goBack();
                } else {
                    this.props.history.push("/winterwork/", { selectedList: this.state.inMemory.selectedList, selectedPostalCode: this.state.inMemory.selectedPostalCode });
                }
            } else {
                eval(whereTo);
            }
        }
    };

    render = () => {
        let contents = this.state.loading ? (
            <Grid container spacing={3} style={{ textAlign: "center" }}>
                <Grid item xs={12}>
                    <CircularProgress />
                </Grid>
            </Grid>
        ) : (
            this.renderMain(this.props)
        );

        const { classes } = this.props;
        return (
            <Container>
                <AppBar style={{ backgroundColor: "rgb(77 106 201)" }}>
                    <Toolbar style={{ height: "95px", padding: "30px" }}>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Go Home" onClick={() => this.saveAndRedirect("back")}>
                            <ArrowBackRounded fontSize="large" />
                        </IconButton>
                        <Typography variant="h4" className={classes.userName}>
                            {this.state?.projectLine?.project?.address?.name ?? "Óskráð"}
                        </Typography>
                        {this.state.projectLine?.project?.address?.latitude && this.state.projectLine?.project?.address?.longitude && (
                            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Maps" onClick={this.openGoogleMaps}>
                                <Map fontSize="large" />
                            </IconButton>
                        )}
                    </Toolbar>
                </AppBar>
                <Toolbar style={{ height: "103px" }} />
                <br />
                <Container>{contents}</Container>
            </Container>
        );
    };
}

export default withSnackbar(withStyles(styles)(withTranslation()(withRouter(WinterWorkClock))));
